// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast {

    display: block;

    border-radius: 12px;
    background: #181c3d!important;

    padding: 20px 35px 20px 25px;

    box-shadow: 0 6px 20px -5px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transform: translateX(0%);
    transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.35);
    z-index: 100;
    animation: appearInfos 0.3s ease-in-out;
    animation-fill-mode: forwards;
}
.message span{
    color:greenyellow;
}
@keyframes appearInfos {
    0% {
        opacity: 0.3;
        transform: translateY(-200px);
        

    }
    100% {
        opacity: 1;
        transform: translateY(0);



    }
}

.toast.active {
    transform: translateX(0%);
}
.toast.disable{
    animation: disAppear 0.5s ease-in-out;
    animation-fill-mode: forwards;
}
@keyframes disAppear {
    0% {
        opacity: 1;
        transform: translateY(0);


    }
    50%{
        transform: translateY(100px);

    }
    100% {
        
        transform: translateY(-200px);


    }
}



.toast .toast-contentInf {
    display: flex;
    align-items: center;
}

.toast-contentInf .infor {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    min-width: 35px;
    background-color: #2f2fe5 !important;

    color: #fff;
    font-size: 50px;
    border-radius: 50%;
}

.toast-contentInf .message {
    display: flex;
    flex-direction: column;
    margin: 0 20px;
}

.message .text {
    font-size: 16px;
    font-weight: 400;
    color: whitesmoke;
    font-family: Poppins, sans-serif
}

.message .text.text-1 {
    font-weight: 600;
    color: whitesmoke;
}

.toast .close {
    position: absolute;
    top: 10px;
    right: 15px;
    padding: 5px;
    cursor: pointer;
    opacity: 0.7;
}

.toast .close:hover {
    opacity: 1;
}

.toast .progressInf {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 100%;

}

.toast .progressInf:before {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background-color: #2f2fe5 !important;
}

.progressInf.active:before {
    animation: progress 2s linear forwards;
}
@keyframes progress {
    100% {
        right: 100%;
    }
}
.toast:not(.show){
    display: block !important;
}
.fa-xmark.close{
    color:red;
}
.fa.close:hover{
    color:red;
    border: none !important; /* Или border: 0; */

}
.hover_close:hover{
    color: red !important;

}
.infor{
    font-size: 40px !important;
    color: #2f2fe5 !important;
}
/*.tel{*/
/*    text-align: center;*/
/*    display: flex;*/
/*    width: 100%;*/

/*    justify-content: center;*/
/*    align-items: center;*/
/*}*/`, "",{"version":3,"sources":["webpack://./src/components/UI/Notification/Information.css"],"names":[],"mappings":"AAAA;;IAEI,cAAc;;IAEd,mBAAmB;IACnB,6BAA6B;;IAE7B,4BAA4B;;IAE5B,8CAA8C;IAC9C,gBAAgB;IAChB,yBAAyB;IACzB,2DAA2D;IAC3D,YAAY;IACZ,uCAAuC;IACvC,6BAA6B;AACjC;AACA;IACI,iBAAiB;AACrB;AACA;IACI;QACI,YAAY;QACZ,6BAA6B;;;IAGjC;IACA;QACI,UAAU;QACV,wBAAwB;;;;IAI5B;AACJ;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,qCAAqC;IACrC,6BAA6B;AACjC;AACA;IACI;QACI,UAAU;QACV,wBAAwB;;;IAG5B;IACA;QACI,4BAA4B;;IAEhC;IACA;;QAEI,6BAA6B;;;IAGjC;AACJ;;;;AAIA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,oCAAoC;;IAEpC,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;;AAEf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;IACT,uBAAuB,EAAE,mBAAmB;;AAEhD;AACA;IACI,qBAAqB;;AAEzB;AACA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA,QAAQ;AACR,0BAA0B;AAC1B,qBAAqB;AACrB,mBAAmB;;AAEnB,+BAA+B;AAC/B,2BAA2B;AAC3B,IAAI","sourcesContent":[".toast {\r\n\r\n    display: block;\r\n\r\n    border-radius: 12px;\r\n    background: #181c3d!important;\r\n\r\n    padding: 20px 35px 20px 25px;\r\n\r\n    box-shadow: 0 6px 20px -5px rgba(0, 0, 0, 0.1);\r\n    overflow: hidden;\r\n    transform: translateX(0%);\r\n    transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.35);\r\n    z-index: 100;\r\n    animation: appearInfos 0.3s ease-in-out;\r\n    animation-fill-mode: forwards;\r\n}\r\n.message span{\r\n    color:greenyellow;\r\n}\r\n@keyframes appearInfos {\r\n    0% {\r\n        opacity: 0.3;\r\n        transform: translateY(-200px);\r\n        \r\n\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n\r\n\r\n\r\n    }\r\n}\r\n\r\n.toast.active {\r\n    transform: translateX(0%);\r\n}\r\n.toast.disable{\r\n    animation: disAppear 0.5s ease-in-out;\r\n    animation-fill-mode: forwards;\r\n}\r\n@keyframes disAppear {\r\n    0% {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n\r\n\r\n    }\r\n    50%{\r\n        transform: translateY(100px);\r\n\r\n    }\r\n    100% {\r\n        \r\n        transform: translateY(-200px);\r\n\r\n\r\n    }\r\n}\r\n\r\n\r\n\r\n.toast .toast-contentInf {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.toast-contentInf .infor {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 35px;\r\n    min-width: 35px;\r\n    background-color: #2f2fe5 !important;\r\n\r\n    color: #fff;\r\n    font-size: 50px;\r\n    border-radius: 50%;\r\n}\r\n\r\n.toast-contentInf .message {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 0 20px;\r\n}\r\n\r\n.message .text {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    color: whitesmoke;\r\n    font-family: Poppins, sans-serif\r\n}\r\n\r\n.message .text.text-1 {\r\n    font-weight: 600;\r\n    color: whitesmoke;\r\n}\r\n\r\n.toast .close {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 15px;\r\n    padding: 5px;\r\n    cursor: pointer;\r\n    opacity: 0.7;\r\n}\r\n\r\n.toast .close:hover {\r\n    opacity: 1;\r\n}\r\n\r\n.toast .progressInf {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    height: 3px;\r\n    width: 100%;\r\n\r\n}\r\n\r\n.toast .progressInf:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    background-color: #2f2fe5 !important;\r\n}\r\n\r\n.progressInf.active:before {\r\n    animation: progress 2s linear forwards;\r\n}\r\n@keyframes progress {\r\n    100% {\r\n        right: 100%;\r\n    }\r\n}\r\n.toast:not(.show){\r\n    display: block !important;\r\n}\r\n.fa-xmark.close{\r\n    color:red;\r\n}\r\n.fa.close:hover{\r\n    color:red;\r\n    border: none !important; /* Или border: 0; */\r\n\r\n}\r\n.hover_close:hover{\r\n    color: red !important;\r\n\r\n}\r\n.infor{\r\n    font-size: 40px !important;\r\n    color: #2f2fe5 !important;\r\n}\r\n/*.tel{*/\r\n/*    text-align: center;*/\r\n/*    display: flex;*/\r\n/*    width: 100%;*/\r\n\r\n/*    justify-content: center;*/\r\n/*    align-items: center;*/\r\n/*}*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
